const isAnimatedGif = (function(){
  var test = function(arr, cb){
    var i, len, frames = 0, length = arr.length;

    // make sure it's a gif (GIF8)
    if (arr[0] !== 0x47 || arr[1] !== 0x49 ||
        arr[2] !== 0x46 || arr[3] !== 0x38) {
      cb(false);
    }

    //ported from php http://www.php.net/manual/en/function.imagecreatefromgif.php#104473
    //an animated gif contains multiple "frames", with each frame having a
    //header made up of:
    // * a static 4-byte sequence (\x00\x21\xF9\x04)
    // * 4 variable bytes
    // * a static 2-byte sequence (\x00\x2C) (some variants may use \x00\x21 ?)
    // We read through the file til we reach the end of the file, or we've found
    // at least 2 frame headers
    for (i=0, len = length - 9; i < len && frames < 2; ++i) {
      if (arr[i] === 0x00 && arr[i+1] === 0x21 &&
          arr[i+2] === 0xF9 && arr[i+3] === 0x04 &&
          arr[i+8] === 0x00 &&
          (arr[i+9] === 0x2C || arr[i+9] === 0x21)) {
        frames++;
      }
    }

    cb(frames > 1);
  };

  var isAnimatedGif = function(src, cb) {
    var base64 = src.match(/.*base64,(.*)/), buffer, arr;

    if(base64){
      if ( src.indexOf('image/gif') === -1 ) {
        cb(false);
        return;
      }

      base64 = base64[1];
      buffer = _base64ToArrayBuffer(base64);
      arr = new Uint8Array(buffer);
      test(arr, cb);
    } else {
      encodeImageURLAsDataURL(src, function(arr){
        isAnimatedGif(arr, cb);
      });
    }
  };

  var _base64ToArrayBuffer = function(base64) {
    var binary_string =  window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array( len );
    for (var i = 0; i < len; i++)        {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  };

  var encodeImageURLAsDataURL = function(src, cb){
    function loadXHR(url) {
      return new Promise(function(resolve, reject) {
        try {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url);
          xhr.responseType = "blob";
          xhr.onerror = function() {
            reject("Network error.");
          };
          xhr.onload = function() {
            if (xhr.status === 200) {
              resolve(xhr.response);
            } else {
              reject("Loading error:" + xhr.statusText);
            }
          };
          xhr.send();
        }
        catch(err) {reject(err.message)}
      });
    }

    loadXHR(src).then(function(blob){
      var reader  = new FileReader();
      var buffer = $('<img/>');

      reader.onloadend = function () {
        buffer.imagesLoaded().
          done(function(){
            cb(reader.result);
          }).attr('src', reader.result);
      }
      reader.readAsDataURL(blob);
    });
  };

  return isAnimatedGif;
})();


export default isAnimatedGif;
